module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('l-toggle'), _vm._v(" "), _c('l-key', {
    ref: "theKey"
  }), _vm._v(" "), _c('l-tile-select', {
    ref: "selectTile",
    on: {
      "map": _vm.changeUrl
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-402f847e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/TileLayer.vue
// module id = 95
// module chunks = 1